<template>
  <fragment>
    <div id="infobar-settings-sidebar" class="infobar-settings-sidebar">
      <div
        class="infobar-settings-sidebar-head d-flex w-100 justify-content-between"
      >
        <h4>I miei filtri</h4>
        <a href="#" id="infobar-settings-close" class="infobar-settings-close">
          <img
            src="assets/images/svg-icon/close.svg"
            class="img-fluid menu-hamburger-close"
            alt="close"
          />
        </a>
      </div>

      <div class="infobar-settings-sidebar-body">
       
        <table class="table w-100 no-footer">
<tbody>
    <tr v-for="item in items" v-bind:key="item.userFilterId">
        <td><editable-label :item="item" :label="item.description"  @update-label="renameFilter" ></editable-label>  
        
        </td>
        <td class="text-right">
<button class="btn btn-xs btn-info-rgba mr-2" title="Esegui filtro" v-on:click="playFilter(item.userFilterId)">
  <i class="feather icon-play"></i>
</button>
<button class="btn btn-xs btn-danger-rgba" title="Elimina filtro"  v-on:click="removeFilter(item.userFilterId)">
  <i class="feather icon-trash"></i>
</button>

        </td>
    </tr>
</tbody>

        </table>
      </div>
    </div>
    <div class="infobar-settings-sidebar-overlay"></div>
  </fragment>
</template>
 <script>
let vm_scope;
import axios from "axios";
export default {
    computed: {
   
    cuser() {
      return this.$store.state.user;
    }
  },
  name: "sidebar",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    }
   
  },
  components: {},
  data() {
    return {
     
      isloading: false,
      items:[]
    };
  },
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
   renameFilter:function(name,filter){
filter.description=name;
this.saveFilter(filter);

   },
playFilter:function(id){
  var me =this;
axios.get('userfilter/'+id).then((result)=>{
 me.$emit("setFilter", result.data);
$('#infobar-settings-close').trigger('click');
});

}
,
removeFilter:function(id){
  var me =this;
  me.$swal({
        title: ``,
        html: `Sicuri di eliminare la risorsa?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .delete('userfilter/'+id)
            .then((response) => {
              me.$swal({
                title: "Cancellazione avvenuta con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

             me.loaddata();
            });
        }
      });

}
,
    saveFilter:function(filter){
      var me = this;
axios.post('userfilter',filter).then((result)=>{
  console.log('userfilter',result,filter)
  me.$emit("setFilter", result.data);
me.loaddata();

});

    },
 
    loaddata: function () {
      var me = this;
      this.isloading = true;
      axios.get('userfilter').then(function (result) {
        me.items = result.data;
       me.$emit("filters", me.items);
       if(me.items.length==0){
         $('#infobar-settings-close').trigger('click');
       }
      });
      
    },
  }
};
</script>
